/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttendanceStatus } from './AttendanceStatus';
import {
    AttendanceStatusFromJSON,
    AttendanceStatusFromJSONTyped,
    AttendanceStatusToJSON,
    AttendanceStatusToJSONTyped,
} from './AttendanceStatus';

/**
 * Schema for reading workshop attendance.
 * @export
 * @interface WorkshopAttendanceRead
 */
export interface WorkshopAttendanceRead {
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceRead
     */
    workshop_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceRead
     */
    user_id: string;
    /**
     * 
     * @type {AttendanceStatus}
     * @memberof WorkshopAttendanceRead
     */
    status?: AttendanceStatus;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopAttendanceRead
     */
    checked_in_at?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceRead
     */
    notes?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopAttendanceRead
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceRead
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceRead
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceRead
     */
    last_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceRead
     */
    user_email?: string | null;
}



/**
 * Check if a given object implements the WorkshopAttendanceRead interface.
 */
export function instanceOfWorkshopAttendanceRead(value: object): value is WorkshopAttendanceRead {
    if (!('workshop_id' in value) || value['workshop_id'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function WorkshopAttendanceReadFromJSON(json: any): WorkshopAttendanceRead {
    return WorkshopAttendanceReadFromJSONTyped(json, false);
}

export function WorkshopAttendanceReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopAttendanceRead {
    if (json == null) {
        return json;
    }
    return {
        
        'workshop_id': json['workshop_id'],
        'user_id': json['user_id'],
        'status': json['status'] == null ? undefined : AttendanceStatusFromJSON(json['status']),
        'checked_in_at': json['checked_in_at'] == null ? undefined : (new Date(json['checked_in_at'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'id': json['id'],
        'username': json['username'] == null ? undefined : json['username'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'user_email': json['user_email'] == null ? undefined : json['user_email'],
    };
}

export function WorkshopAttendanceReadToJSON(json: any): WorkshopAttendanceRead {
    return WorkshopAttendanceReadToJSONTyped(json, false);
}

export function WorkshopAttendanceReadToJSONTyped(value?: WorkshopAttendanceRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workshop_id': value['workshop_id'],
        'user_id': value['user_id'],
        'status': AttendanceStatusToJSON(value['status']),
        'checked_in_at': value['checked_in_at'] == null ? undefined : ((value['checked_in_at'] as any).toISOString()),
        'notes': value['notes'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'id': value['id'],
        'username': value['username'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'user_email': value['user_email'],
    };
}

